module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoBAMAAAB+0KVeAAAAD1BMVEUAAADU1NTd3d3d3d3d3d0J0pw3AAAABHRSTlMABojuA/bHFAAAAElJREFUeAFjgAFGZSMBBnTA5OKigCHI7OJigCHI4uLigEtwVFDIxAUNOCsyqLhgACcGhEKEUqyCWLVjtYiAO0cFMZM3oYyAmWUAyxQ4lUgfCVAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/grey-plus.png
// module id = OP9l
// module chunks = 216